export default __webpack_public_path__ + "static/media/FSEmericWeb-Regular.0a84e7c5.woff";